import TabulatorOnCellClickAction from "@root/enums/TabulatorOnCellClickAction";
import filterMainTable from "@root/tabulator/onCellClickActions/filterMainTable";

export default function (name) {
  return {
    [TabulatorOnCellClickAction.FILTER_MAIN_TABLE.enumKey]: filterMainTable,
  }[name.toUpperCase()] || null;

}
